import { render, staticRenderFns } from "./scoreboard_full.vue?vue&type=template&id=245259a3&"
import script from "./scoreboard_full.vue?vue&type=script&lang=js&"
export * from "./scoreboard_full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EventScoreboardStatbox: require('/var/web/bet777.es/components/event/scoreboard_statbox.vue').default})
